const Footer = () => {
  return <footer className="app-footer text-center p-2">© 2026 Tnemis</footer>;
};

export default Footer;
